export default __webpack_public_path__ + "static/media/status-warning-alt-filled.fd287c94.svg";